import script from "./OtpValidate.vue?vue&type=script&lang=ts&setup=true"
export * from "./OtpValidate.vue?vue&type=script&lang=ts&setup=true"

import "./OtpValidate.vue?vue&type=style&index=0&id=314a83da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314a83da"]])

export default __exports__